const currentDate = new Date();
var ELocalStorageKeys;
(function (ELocalStorageKeys) {
    ELocalStorageKeys["FIRST_TOUCH_ORIGINATION"] = "firstTouchOrigination";
})(ELocalStorageKeys || (ELocalStorageKeys = {}));
export function getOriginationFromUrl(url) {
    const searchParams = new URLSearchParams(url);
    const sourceId = searchParams.get('sourceId') ?? searchParams.get('utm_source') ?? searchParams.get('sid');
    const campaignId = searchParams.get('campaignId') ?? searchParams.get('utm_campaign') ?? searchParams.get('cid');
    const mediumId = searchParams.get('mediumId') ?? searchParams.get('utm_medium') ?? searchParams.get('mid');
    const brandId = searchParams.get('brandId') ?? searchParams.get('br');
    const referrer = searchParams.get('referrer') ?? document.referrer;
    const referrerDomain = stripProtocol(referrer);
    if (sourceId || mediumId || campaignId || brandId || referrer) {
        return { sourceId, campaignId, mediumId, trackedOn: currentDate, brandId: brandId, referrerDomain: referrerDomain };
    }
    return null;
}
export function setOriginationStorage(currentOrigination) {
    let firstOrigination = getFirstOriginationFromStorage();
    if (firstOrigination == null) {
        firstOrigination = currentOrigination;
    }
    const normalized = normalizeOrigination(firstOrigination);
    setOriginationValue(normalized, ELocalStorageKeys.FIRST_TOUCH_ORIGINATION);
}
export function getFirstOriginationFromStorage() {
    const storedValue = localStorage.getItem(ELocalStorageKeys.FIRST_TOUCH_ORIGINATION);
    const origination = storedValue ? JSON.parse(storedValue) : null;
    if (!origination)
        return null;
    origination.referrerDomain = stripProtocol(origination.referrerDomain ?? null);
    const elapsedTime = origination?.trackedOn ? Math.floor((currentDate.getTime() - new Date(origination.trackedOn).getTime()) / (1000 * 60 * 60 * 24)) : 0;
    return elapsedTime >= 30 ? null : origination;
}
export function setOriginationValue(origination, key) {
    if (origination != null) {
        localStorage.setItem(key, JSON.stringify(origination));
    }
    else {
        localStorage.removeItem(key);
    }
}
export function isEquivalentToSavedOrigination(origination) {
    const firstOrigination = getFirstOriginationFromStorage();
    return firstOrigination?.campaignId === origination?.campaignId &&
        firstOrigination?.mediumId === origination?.mediumId &&
        firstOrigination?.sourceId === origination?.sourceId;
}
function normalizeOrigination(origination) {
    if (!origination)
        return null;
    return {
        ...origination,
        referrerDomain: stripProtocol(origination.referrerDomain)
    };
}
export function stripProtocol(value) {
    if (!value)
        return null;
    return value.replace(/^[a-z]+:\/\//i, '');
}
